var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIconAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9333 19.6453C18.4061 20.1181 19.1727 20.1181 19.6455 19.6453C20.1183 19.1725 20.1183 18.4059 19.6455 17.9331L11.7123 9.99992L19.6453 2.06689C20.1181 1.59409 20.1181 0.82751 19.6453 0.354701C19.1725 -0.118108 18.4059 -0.118108 17.9331 0.354701L10.0001 8.28773L2.06697 0.354607C1.59417 -0.118202 0.82759 -0.118202 0.354781 0.354607C-0.118028 0.827416 -0.118027 1.59399 0.354781 2.0668L8.2879 9.99992L0.354607 17.9332C-0.118202 18.406 -0.118202 19.1726 0.354607 19.6454C0.827416 20.1182 1.59399 20.1182 2.0668 19.6454L10.0001 11.7121L17.9333 19.6453Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIconAlt);
export default __webpack_public_path__ + "static/media/close-icon-alt.0b141ef4.svg";
export { ForwardRef as ReactComponent };